import React from 'react';

const Legal = () => {
  return (
    <div className="bg-white">
      {/* Hero */}
      <section className="bg-gray-900 text-white py-20">
        <div className="container mx-auto px-4 text-center">
          <h1 className="text-5xl font-bold mb-4">Mentions Légales</h1>
          <p className="text-xl">Informations légales et réglementaires</p>
        </div>
      </section>

      {/* Content */}
      <section className="container mx-auto px-4 py-16">
        <div className="max-w-4xl mx-auto prose prose-lg">
          <h2 className="text-3xl font-bold text-gray-900 mb-6">1. Éditeur du site</h2>
          <p className="text-gray-700 mb-4">
            Le site www.neopliage.fr est édité par :
          </p>
          <p className="text-gray-700 mb-4">
            <strong>NEOMAT</strong><br />
            Marque : NEOPLIAGE<br />
            Forme juridique : SAS<br />
            Adresse : 23 Avenue de la Libération, 01500 Ambérieu-en-Bugey, France<br />
            Téléphone : 06.37.06.03.16<br />
            Email : contact@neopliage.fr
          </p>

          <h2 className="text-3xl font-bold text-gray-900 mb-6 mt-12">2. Hébergement</h2>
          <p className="text-gray-700 mb-4">
            Le site est hébergé par :<br />
            <strong>Emergent AG</strong><br />
            Services cloud professionnels
          </p>

          <h2 className="text-3xl font-bold text-gray-900 mb-6 mt-12">3. Directeur de publication</h2>
          <p className="text-gray-700 mb-4">
            Le directeur de la publication du site est le représentant légal de NEOMAT.
          </p>

          <h2 className="text-3xl font-bold text-gray-900 mb-6 mt-12">4. Propriété intellectuelle</h2>
          <p className="text-gray-700 mb-4">
            L'ensemble du contenu de ce site (textes, images, vidéos, logos, etc.) est la propriété exclusive de NEOMAT 
            ou fait l'objet d'une autorisation d'utilisation.
          </p>
          <p className="text-gray-700 mb-4">
            Toute reproduction, représentation, modification, publication, transmission ou dénaturation, totale ou partielle 
            du site ou de son contenu, par quelque procédé que ce soit, et sur quelque support que ce soit est interdite 
            sans l'autorisation écrite préalable de NEOMAT.
          </p>

          <h2 className="text-3xl font-bold text-gray-900 mb-6 mt-12">5. Données personnelles</h2>
          <p className="text-gray-700 mb-4">
            Conformément au Règlement Général sur la Protection des Données (RGPD) et à la loi Informatique et Libertés, 
            vous disposez d'un droit d'accès, de rectification, de suppression et d'opposition aux données personnelles 
            vous concernant.
          </p>
          <p className="text-gray-700 mb-4">
            Pour exercer ces droits, vous pouvez nous contacter par email à : contact@neopliage.fr
          </p>

          <h2 className="text-3xl font-bold text-gray-900 mb-6 mt-12">6. Cookies</h2>
          <p className="text-gray-700 mb-4">
            Le site utilise des cookies techniques nécessaires à son bon fonctionnement. Ces cookies ne collectent pas 
            de données personnelles et ne nécessitent pas votre consentement.
          </p>

          <h2 className="text-3xl font-bold text-gray-900 mb-6 mt-12">7. Limitation de responsabilité</h2>
          <p className="text-gray-700 mb-4">
            NEOMAT s'efforce d'assurer l'exactitude et la mise à jour des informations diffusées sur ce site. 
            Toutefois, NEOMAT ne peut garantir l'exactitude, la précision ou l'exhaustivité des informations mises à disposition.
          </p>

          <h2 className="text-3xl font-bold text-gray-900 mb-6 mt-12">8. Droit applicable</h2>
          <p className="text-gray-700 mb-4">
            Les présentes mentions légales sont régies par le droit français. En cas de litige, les tribunaux français 
            seront seuls compétents.
          </p>

          <p className="text-gray-700 mt-12">
            <em>Dernière mise à jour : Février 2025</em>
          </p>
        </div>
      </section>
    </div>
  );
};

export default Legal;
